<app-header (ionChange)="onIonChange($event)"> </app-header>
<ion-content scrollbar class="ion-content-padding-top-0">
  <ion-grid>
    <ion-row
      *ngIf="activeSegment === '0'; else Community"
      class="small-padding"
      justify-content-center
    >
      <ion-col
        class="desktop-header no-padding-top"
        *ngIf="platform.width()>=1200"
        size-xl="2"
      >
        <ion-grid class="box no-padding-top">
          <ion-row class="small-padding" justify-content-center>
            <ion-col
              class="full-width no-padding integration-trip no-padding-top"
            >
              <div>
                <div
                  *ngFor="let m of menu"
                  [ngClass]="'integration-trip__menu-value' + (currentMenuValue === m ? ' integration-trip__active-menu' : ' integration-trip__inactive-menu')"
                >
                  <ion-item
                    [ngClass]="'input header-option-title cursor-pointer' + (currentMenuValue === m ? ' header-option-selected' : '')"
                    lines="none"
                    (click)="currentMenuValue = m"
                  >
                    <ion-text>{{m.name}}</ion-text>
                  </ion-item>
                </div>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
      <ion-col class="full-width integration-trip" size="12" size-xl="10">
        <div>
          <div *ngFor="let c of currentMenuValue?.questions">
            <div
              *ngIf="c.title"
              class="integration-trip__question-title ion-text-center"
            >
              {{c.title}}
            </div>
            <div
              class="info__question-content-wrapper td-text-align-left"
              [innerHTML]="c.content | sanitizeHtml"
            ></div>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ng-template #Community>
    <ion-row
      class="small-padding integration-trip__post"
      justify-content-center
    >
      <ion-col>
        <div class="margin-bottom-8">
          <app-search-bar
            #searchBar
            (searchEvent)="searchNews()"
            [permissionEdit]="permissionAdmin"
            buttonAddLabel="{{'ADD_NEW_POST' | translate }}"
            addLink="/app/integration-trip/edit-community/{{comType}}/0"
          ></app-search-bar>
        </div>
        <ng-container
          [ngTemplateOutlet]="(comType === CommunityType.Agenda) ? groupedNewsTemplate : news"
        ></ng-container>
        <ion-infinite-scroll (ionInfinite)="loadNews($event)">
          <ion-infinite-scroll-content
            loadingSpinner="bubbles"
            loadingText="{{ 'INFINITE_LOADER_INFO_TEXT' | translate }}"
          >
          </ion-infinite-scroll-content>
        </ion-infinite-scroll>
      </ion-col>
    </ion-row>
  </ng-template>
  <ion-fab
    *ngIf="p.renderMobile && permissionAdmin && activeSegment === '1'"
    vertical="bottom"
    horizontal="end"
    slot="fixed"
  >
    <ion-fab-button routerLink="/app/integration-trip/edit-community/{{comType}}/0">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>


<ng-template #news>
  <div>
    <no-result [collection]="communityServ.communities"> </no-result>
    <app-item-community
      *ngFor="let item of newsVisible"
      [community]="item"
      [currentSegment]="comType"
      [communityAdmin]="permissionAdmin"
      (refreshRequest)="getNews()"
    ></app-item-community>
  </div>
</ng-template>

<ng-template #groupedNewsTemplate>
  <div class="margin-bottom-8">
    <ion-chip 
      *ngFor="let day of days" 
      [ngClass]="'integration-trip__chip ' + (selectedDay === day ? 'integration-trip__chip--active' : 'integration-trip__chip--inactive')"
      (click)="onDayChipClick(day)"
    >
      {{ getDayLabel(day) }}
    </ion-chip>
  </div>
  <div>
    <no-result [collection]="groupedNews[selectedDay] || []"> </no-result>
    <app-item-community
      *ngFor="let item of groupedNews[selectedDay] || []"
      [community]="item"
      [currentSegment]="comType"
      [communityAdmin]="permissionAdmin"
      (refreshRequest)="getNews()"
    ></app-item-community>
  </div>
</ng-template>
